import React from 'react';

const OPS = [
  { kind: 'OP', operator: 'ADD', label: '+' },
  { kind: 'OP', operator: 'SUBTRACT', label: '−' },
  { kind: 'OP', operator: 'MULTIPLY', label: '×' },
  { kind: 'OP', operator: 'DIVIDE', label: '÷' },
  { kind: 'OP', operator: 'MIN', label: 'MIN' },
  { kind: 'OP', operator: 'MAX', label: 'MAX' },
];

const FormulaBlockBuilder = ({ readOnly, fields, blocks, formulaJson, onChangeBlocks }) => {
  const list = Array.isArray(blocks) ? blocks : [];
  const fieldOpts = (fields || []).filter((f) => String(f.status || 'ACTIVE') === 'ACTIVE');

  const push = (block) => onChangeBlocks([...list, block]);
  const removeAt = (idx) => onChangeBlocks(list.filter((_, i) => i !== idx));

  const preview = list.map((b) => {
    if (b.kind === 'OP') return b.operator === 'MULTIPLY' ? '×' : b.operator === 'SUBTRACT' ? '−' : b.operator === 'DIVIDE' ? '÷' : b.operator === 'ADD' ? '+' : b.operator;
    if (b.kind === 'FIELD') return fieldOpts.find((f) => f.fieldCode === b.fieldCode)?.fieldLabel || b.fieldCode;
    if (b.kind === 'PREVIOUS') return `Prev(${b.fieldCode})`;
    if (b.kind === 'CONSTANT') return String(b.value);
    if (b.kind === 'PERCENT') return `${b.value}%`;
    return '?';
  }).join(' ');

  return (
    <div className="ra-tpl-formula-builder">
      <label>Formula Builder</label>
      <div className="ra-tpl-formula-preview">{preview || 'Add fields and operators below'}</div>
      <div className="ra-tpl-formula-chips">
        {list.map((b, idx) => (
          <span key={idx} className="ra-tpl-chip">
            {b.kind === 'FIELD' ? (fieldOpts.find((f) => f.fieldCode === b.fieldCode)?.fieldLabel || b.fieldCode) : b.kind === 'OP' ? (OPS.find((o) => o.operator === b.operator)?.label || b.operator) : b.kind === 'PERCENT' ? `${b.value}%` : b.value}
            {!readOnly && <button type="button" onClick={() => removeAt(idx)}>×</button>}
          </span>
        ))}
      </div>
      {!readOnly && (
        <div className="ra-tpl-formula-tools">
          <select defaultValue="" onChange={(e) => {
            if (!e.target.value) return;
            push({ kind: 'FIELD', fieldCode: e.target.value });
            e.target.value = '';
          }}
          >
            <option value="">+ Field</option>
            {fieldOpts.map((f) => <option key={f.fieldCode} value={f.fieldCode}>{f.fieldLabel || f.fieldCode}</option>)}
          </select>
          <select defaultValue="" onChange={(e) => {
            if (!e.target.value) return;
            push({ kind: 'PREVIOUS', fieldCode: e.target.value });
            e.target.value = '';
          }}
          >
            <option value="">+ Previous RA Field</option>
            {fieldOpts.map((f) => <option key={f.fieldCode} value={f.fieldCode}>{f.fieldLabel || f.fieldCode}</option>)}
          </select>
          {OPS.map((o) => (
            <button key={o.operator} type="button" className="btn-secondary btn-sm" onClick={() => push({ kind: 'OP', operator: o.operator })}>{o.label}</button>
          ))}
          <button
            type="button"
            className="btn-secondary btn-sm"
            onClick={() => {
              const v = window.prompt('Constant value');
              if (v == null || v === '') return;
              push({ kind: 'CONSTANT', value: Number(v) || 0 });
            }}
          >
            + Constant
          </button>
          <button
            type="button"
            className="btn-secondary btn-sm"
            onClick={() => {
              const v = window.prompt('Percentage rate');
              if (v == null || v === '') return;
              push({ kind: 'PERCENT', value: Number(v) || 0 });
            }}
          >
            + %
          </button>
        </div>
      )}
      {formulaJson && !list.length && (
        <p className="ra-tpl-help">Existing custom formula is preserved. Use the builder to replace it, or leave as-is.</p>
      )}
    </div>
  );
};

export default FormulaBlockBuilder;
